import Profile from "../Profile/Profile";
import AuthorLoading from "./AuthorLoading";
import "./Author.css";
import { useState, useEffect } from "react";
import axios from "axios";

function Author({ author_id }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(false);
  const authorDataPath = process.env.REACT_APP_AUTHOR_DATA_PATH;
  const apiKey = process.env.REACT_APP_API_KEY;
  const backend = process.env.REACT_APP_BACKEND_LINK;

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(authorDataPath + `${author_id}`, {
          headers: { Authorization: `Api-Key ${apiKey}` },
        });
        setData(response.data);
      } catch {
        setError("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [authorDataPath, apiKey, author_id]);

  if (loading) return <AuthorLoading />;

  if (!data) return null;

  return (
    <section id="author">
      <div className="author-container">
        <Profile
          url={data.profile && data.profile.replace(/^https?:\/\/[^/]+/, backend)}
        />
        <div className="author-text">
          <div className="author-header">
            <h3 className="primary-text author-name">{data.name}</h3>
            <div className="author-divider" />
          </div>
          <p className="primary-text author-bio">{data.bio}</p>
        </div>
      </div>
    </section>
  );
}

export default Author;
